/** Column widths changed by the user (OIL-46): session only per table id, like sort and order. */
export const MIN_COLUMN_WIDTH = 48;
export const MAX_COLUMN_WIDTH = 800;
/** Keyboard step of the resize handle (px). */
export const RESIZE_STEP = 16;

const sessionWidths = new Map<string, Readonly<Record<string, number>>>();

export function clampWidth(w: number): number {
  return Math.round(Math.min(MAX_COLUMN_WIDTH, Math.max(MIN_COLUMN_WIDTH, w)));
}

export function sessionColumnWidths(id: string): Readonly<Record<string, number>> {
  return sessionWidths.get(id) ?? {};
}

/** Sets (or with `null` resets) the width of one column; returns the new widths. */
export function saveColumnWidth(
  id: string,
  key: string,
  width: number | null,
): Readonly<Record<string, number>> {
  const next = { ...sessionColumnWidths(id) };
  if (width === null) delete next[key];
  else next[key] = clampWidth(width);
  if (Object.keys(next).length === 0) sessionWidths.delete(id);
  else sessionWidths.set(id, next);
  return next;
}

/** Effective widths: user width, else the column's own, else the type default. */
export function effectiveWidths<C extends { key: string; width?: number }>(
  columns: readonly C[],
  overrides: Readonly<Record<string, number>>,
  fallback: (c: C) => number,
): number[] {
  return columns.map((c) => overrides[c.key] ?? c.width ?? fallback(c));
}
